import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LOGO, NavBar, FB_URL, IG_URL, WHATSAPP, RECEPTION_WHATSAPP, BANK, ADDRESS } from "../shared";

// ─── EDITABLE MENU DATA ────────────────────────────────────────────────────────
// To update prices: change the price number
// To add items: copy any item block and add to the array
// To remove items: delete that item block
const INITIAL_MENU = [
  {
    id: "breakfast", label: "Breakfast", icon: "🌅", hours: "6AM – 10AM", color: "#e8963a",
    items: [
      { id: "b1", name: "Yam & Egg Sauce", price: 3500, emoji: "🥚", note: "Fresh yam with spicy egg sauce" },
      { id: "b2", name: "Akara & Pap / Custard", price: 2500, emoji: "🫕", note: "Crispy akara with smooth pap or custard" },
      { id: "b3", name: "Bread & Omelette", price: 2500, emoji: "🍳", note: "Toasted bread with omelette (+ sausage ₦500)" },
      { id: "b4", name: "Indomie Special", price: 3000, emoji: "🍜", note: "Noodles with egg, sausage & vegetables" },
      { id: "b5", name: "Tea / Coffee Combo", price: 2000, emoji: "☕", note: "Hot tea or coffee with bread & butter" },
    ],
  },
  {
    id: "lunch", label: "Lunch & Dinner", icon: "🍛", hours: "From 11AM", color: "#c8860a",
    items: [
      { id: "l1", name: "Smoky Party Jollof Rice", price: 4500, emoji: "🍗", note: "Chicken / Beef / Fish — Most Ordered" },
      { id: "l2", name: "Fried Rice", price: 4500, emoji: "🍚", note: "Chicken / Beef / Fish" },
      { id: "l3", name: "White Rice & Stew", price: 4000, emoji: "🍖", note: "Chicken / Beef / Fish" },
      { id: "l4", name: "Spaghetti Stir Fry", price: 4000, emoji: "🍝", note: "Stir-fried with vegetables & protein" },
    ],
  },
  {
    id: "soups", label: "Soups & Swallow", icon: "🫙", hours: "From 11AM", color: "#9b6a2a",
    items: [
      { id: "sw1", name: "Vegetable Soup", price: 4500, emoji: "🥬", note: "Semo / Pounded Yam / Eba / Oat" },
      { id: "sw2", name: "Egusi Soup", price: 4500, emoji: "🫙", note: "Semo / Pounded Yam / Eba / Oat" },
      { id: "sw3", name: "Ogbono Soup", price: 4500, emoji: "🍲", note: "Semo / Pounded Yam / Eba / Oat" },
      { id: "sw4", name: "Bitterleaf Soup", price: 4500, emoji: "🌿", note: "Semo / Pounded Yam / Eba / Oat" },
    ],
  },
  {
    id: "pepper", label: "Pepper Soup", icon: "🌶️", hours: "From 11AM", color: "#e03a2e",
    items: [
      { id: "ps1", name: "Chicken Pepper Soup", price: 4000, emoji: "🍗" },
      { id: "ps2", name: "Assorted Pepper Soup", price: 4500, emoji: "🥘" },
      { id: "ps3", name: "Fish Pepper Soup", price: 5000, emoji: "🐟" },
      { id: "ps4", name: "Nkwobi", price: 4500, emoji: "🐄", note: "Local Favourite" },
      { id: "ps5", name: "Turkey Pepper Soup", price: 5500, emoji: "🦃" },
      { id: "ps6", name: "Beef Pepper Soup", price: 5000, emoji: "🥩" },
    ],
  },
  {
    id: "specials", label: "401 Weekend Specials", icon: "⭐", hours: "Fri – Sun", color: "#c8860a",
    items: [
      { id: "s1", name: "Abacha (African Salad)", price: 3500, emoji: "🥗", note: "Eastern delicacy with ugba, fish, kpomo & spices — Local Favourite" },
      { id: "s2", name: "Roasted Fish", price: 6000, emoji: "🐟", note: "Grilled fish with pepper sauce (+ fries ₦1,000)" },
      { id: "s3", name: "Roasted Chicken", price: 5500, emoji: "🍗", note: "Juicy grilled chicken (+ fries ₦1,000)" },
      { id: "s4", name: "Suya (Beef / Chicken)", price: 3000, emoji: "🔥", note: "Spicy grilled meat with onions & pepper — With Drinks" },
      { id: "s5", name: "Goat Head", price: 5000, emoji: "🐐", note: "Slow-cooked goat head with spices — Local Favourite" },
      { id: "s6", name: "Dry Fish & Veg Sauce", price: 4500, emoji: "🎣", note: "Rich vegetable sauce with dry fish" },
      { id: "s7", name: "Yam & Chicken", price: 5000, emoji: "🍗", note: "Soft yam served with grilled chicken" },
    ],
  },
  {
    id: "snacks", label: "Snacks / Fast Food", icon: "🍔", hours: "All day", color: "#d4a017",
    items: [
      { id: "f1", name: "Spring Rolls (4 pcs)", price: 2000, emoji: "🥢", note: "Crispy rolls with vegetables and meat" },
      { id: "f2", name: "Meat Pie", price: 1500, emoji: "🥧", note: "Golden baked pastry with seasoned meat" },
      { id: "f3", name: "Chicken Wings & Fries", price: 4000, emoji: "🍗", note: "Crispy wings with golden fries" },
      { id: "f4", name: "Club Sandwich & Fries", price: 3500, emoji: "🥪", note: "Triple-layer chicken, egg & veggie sandwich — Must Try" },
      { id: "f5", name: "Shawarma (Chicken/Beef)", price: 3000, emoji: "🌯", note: "Delicious wrap with creamy sauce" },
    ],
  },
  {
    id: "drinks", label: "Drinks", icon: "🍹", hours: "All day", color: "#2e9e6e",
    items: [
      { id: "d1", name: "Water", price: 500, emoji: "💧" },
      { id: "d2", name: "Soft Drink", price: 500, emoji: "🥤" },
      { id: "d3", name: "Malt", price: 700, emoji: "🧃" },
      { id: "d4", name: "Juice", price: 1000, emoji: "🍊" },
      { id: "d5", name: "Energy Drink", price: 1500, emoji: "⚡" },
      { id: "d6", name: "Fresh Juice", price: 2000, emoji: "🍹" },
    ],
  },
  {
    id: "bar", label: "VIP Bar & O Bar", icon: "🍺", hours: "Evening", color: "#b5860a",
    items: [
      { id: "br1", name: "Beer (Regular)", price: 1500, emoji: "🍺" },
      { id: "br2", name: "Premium Beer", price: 2500, emoji: "🍻" },
      { id: "br3", name: "Wine (Glass)", price: 3000, emoji: "🍷" },
      { id: "br4", name: "Wine (Full Bottle)", price: 15000, emoji: "🍾" },
      { id: "br5", name: "Whiskey Shot", price: 2500, emoji: "🥃" },
    ],
  },
];

const COMBOS_INITIAL = [
  { id: "c1", name: "Jollof Combo", desc: "Smoky Jollof Rice + Chicken + Drink", price: 5500, saving: 500, emoji: "🍗" },
  { id: "c2", name: "Breakfast Combo", desc: "Yam & Egg Sauce + Tea/Coffee", price: 5000, saving: 1000, emoji: "🌅" },
  { id: "c3", name: "Pepper Soup Special", desc: "Fish Pepper Soup + Drink", price: 5500, saving: 500, emoji: "🌶️" },
  { id: "c4", name: "Roasted Fish Deal", desc: "Roasted Fish + Fries + Drink", price: 7000, saving: 500, emoji: "🐟" },
  { id: "c5", name: "Suya Night Special", desc: "Suya + Drink — Fri to Sun", price: 3500, saving: 500, emoji: "🔥" },
];

const fmt = (n) => "₦" + Number(n).toLocaleString();

function genId() { return Date.now().toString(36) + Math.random().toString(36).slice(2, 5); }

export default function MenuEditor() {
  const navigate = useNavigate();
  const [menu, setMenu] = useState(INITIAL_MENU);
  const [combos, setCombos] = useState(COMBOS_INITIAL);
  const [mode, setMode] = useState("view"); // view | admin
  const [adminKey, setAdminKey] = useState("");
  const [keyInput, setKeyInput] = useState("");
  const [activeCat, setActiveCat] = useState("breakfast");
  const [editingItem, setEditingItem] = useState(null); // { catId, itemId } or null
  const [addingItem, setAddingItem] = useState(null); // catId
  const [newItem, setNewItem] = useState({ name: "", price: "", emoji: "🍽️", note: "", image: "" });
  const [saved, setSaved] = useState(false);
  const [tab, setTab] = useState("menu"); // menu | combos

  const ADMIN_PASSWORD = "401kitchen";

  const C = {
    bg: "#0a0702", surface: "#120d04", card: "#1a1206", border: "#2a1e08",
    gold: "#c8860a", goldLight: "#e8a020", goldDim: "#7a5206",
    cream: "#f0e4c8", muted: "#8a7050", red: "#e03a2e", green: "#3aad72",
  };

  const activeCatData = menu.find(c => c.id === activeCat);

  // ── UPDATE ITEM PRICE ────────────────────────────────────────────────────
  const updatePrice = (catId, itemId, newPrice) => {
    setMenu(prev => prev.map(cat =>
      cat.id !== catId ? cat : {
        ...cat,
        items: cat.items.map(item =>
          item.id !== itemId ? item : { ...item, price: Number(newPrice) || item.price }
        )
      }
    ));
  };

  const updateItemName = (catId, itemId, name) => {
    setMenu(prev => prev.map(cat =>
      cat.id !== catId ? cat : {
        ...cat,
        items: cat.items.map(item =>
          item.id !== itemId ? item : { ...item, name }
        )
      }
    ));
  };

  const updateItemImage = (catId, itemId, image) => {
    setMenu(prev => prev.map(cat =>
      cat.id !== catId ? cat : {
        ...cat,
        items: cat.items.map(item =>
          item.id !== itemId ? item : { ...item, image: image.trim() }
        )
      }
    ));
  };

  // ── ADD ITEM ─────────────────────────────────────────────────────────────
  const addItem = (catId) => {
    if (!newItem.name || !newItem.price) return alert("Please enter item name and price.");
    setMenu(prev => prev.map(cat =>
      cat.id !== catId ? cat : {
        ...cat,
        items: [...cat.items, {
          id: genId(),
          name: newItem.name,
          price: Number(newItem.price),
          emoji: newItem.emoji || "🍽️",
          note: newItem.note,
          image: newItem.image.trim() || "",
        }]
      }
    ));
    setNewItem({ name: "", price: "", emoji: "🍽️", note: "", image: "" });
    setAddingItem(null);
    flashSaved();
  };

  // ── REMOVE ITEM ──────────────────────────────────────────────────────────
  const removeItem = (catId, itemId) => {
    if (!window.confirm("Remove this item from the menu?")) return;
    setMenu(prev => prev.map(cat =>
      cat.id !== catId ? cat : { ...cat, items: cat.items.filter(i => i.id !== itemId) }
    ));
  };

  // ── COMBO UPDATES ────────────────────────────────────────────────────────
  const updateCombo = (id, field, val) => {
    setCombos(prev => prev.map(c => c.id !== id ? c : { ...c, [field]: field === "price" || field === "saving" ? Number(val) || c[field] : val }));
  };

  const addCombo = () => {
    setCombos(prev => [...prev, { id: genId(), name: "New Combo", desc: "Item + Item", price: 0, saving: 0, emoji: "🍽️" }]);
  };

  const removeCombo = (id) => {
    if (!window.confirm("Remove this combo?")) return;
    setCombos(prev => prev.filter(c => c.id !== id));
  };

  const flashSaved = () => { setSaved(true); setTimeout(() => setSaved(false), 2000); };

  // ── EXPORT SUMMARY ───────────────────────────────────────────────────────
  const exportSummary = () => {
    let text = "THE 401 HOTEL & SUITES LTD — MENU\n";
    text += "Updated: " + new Date().toLocaleDateString("en-NG") + "\n\n";
    menu.forEach(cat => {
      text += `${cat.label.toUpperCase()} (${cat.hours})\n`;
      cat.items.forEach(item => { text += `  ${item.name} — ${fmt(item.price)}\n`; });
      text += "\n";
    });
    text += "COMBOS\n";
    combos.forEach(c => { text += `  ${c.name}: ${c.desc} — ${fmt(c.price)}\n`; });
    const blob = new Blob([text], { type: "text/plain" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "401_menu_" + new Date().toISOString().split("T")[0] + ".txt";
    a.click();
  };

  // ── STYLES ────────────────────────────────────────────────────────────────
  const inp = { background: C.card, border: `1px solid ${C.border}`, borderRadius: 8, padding: "8px 10px", color: C.cream, fontSize: 13, fontFamily: "inherit", outline: "none", colorScheme: "dark" };

  // ── LOGIN ─────────────────────────────────────────────────────────────────
  const renderLogin = () => (
    <div style={{ padding: 32, textAlign: "center" }}>
      <div style={{ fontSize: 40, marginBottom: 12 }}>🔐</div>
      <div style={{ fontSize: 16, fontWeight: "bold", color: C.gold, marginBottom: 6 }}>Admin Access</div>
      <div style={{ fontSize: 12, color: C.muted, marginBottom: 20 }}>Enter your admin password to edit the menu</div>
      <input type="password" style={{ ...inp, width: "100%", boxSizing: "border-box", padding: "12px 14px", fontSize: 15, marginBottom: 14 }}
        placeholder="Password" value={keyInput} onChange={e => setKeyInput(e.target.value)}
        onKeyDown={e => { if (e.key === "Enter" && keyInput === ADMIN_PASSWORD) setMode("admin"); }} />
      <button onClick={() => { if (keyInput === ADMIN_PASSWORD) setMode("admin"); else alert("Incorrect password."); }}
        style={{ width: "100%", background: `linear-gradient(135deg,${C.gold},${C.goldLight})`, border: "none", borderRadius: 10, padding: "13px", fontSize: 14, fontWeight: "bold", color: C.bg, cursor: "pointer", fontFamily: "inherit" }}>
        Unlock Menu Editor
      </button>
      <button onClick={() => setMode("view")} style={{ marginTop: 12, background: "transparent", border: `1px solid ${C.border}`, borderRadius: 8, padding: "10px 20px", color: C.muted, cursor: "pointer", fontFamily: "inherit", fontSize: 13 }}>
        ← Back to Menu
      </button>
    </div>
  );

  // ── VIEW MODE ────────────────────────────────────────────────────────────
  const renderView = () => (
    <div>
      {/* Category tabs */}
      <div style={{ display: "flex", flexWrap: "wrap", background: C.surface, borderBottom: `1px solid ${C.border}` }}>
        {menu.map(cat => (
          <button key={cat.id} onClick={() => setActiveCat(cat.id)}
            style={{ padding: "11px 14px", border: "none", background: "transparent", color: activeCat === cat.id ? (cat.color || C.gold) : C.muted, fontFamily: "inherit", fontSize: 11, fontWeight: activeCat === cat.id ? "bold" : "normal", cursor: "pointer", whiteSpace: "nowrap", borderBottom: activeCat === cat.id ? `2px solid ${cat.color || C.gold}` : "2px solid transparent", letterSpacing: 1 }}>
            {cat.icon} {cat.label}
          </button>
        ))}
      </div>

      {activeCatData && (
        <div>
          <div style={{ background: C.card, padding: "8px 20px", fontSize: 10, color: C.muted, letterSpacing: 2, borderBottom: `1px solid ${C.border}` }}>
            {activeCatData.icon} {activeCatData.label.toUpperCase()} · {activeCatData.hours}
          </div>
          <div style={{ padding: "12px 18px" }}>
            {activeCatData.items.map(item => (
              <div key={item.id} style={{ display: "flex", alignItems: "center", gap: 12, padding: "13px 0", borderBottom: `1px solid ${C.border}33` }}>
                {/* Image or emoji */}
                <div style={{ width: 64, height: 64, background: activeCatData.color + "15", border: `1px solid ${activeCatData.color}33`, borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 28, flexShrink: 0, overflow: "hidden" }}>
                  {item.image
                    ? <img src={item.image} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} onError={e => { e.target.style.display = "none"; e.target.nextSibling.style.display = "flex"; }} />
                    : null}
                  <span style={{ display: item.image ? "none" : "flex" }}>{item.emoji}</span>
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 14, color: C.cream, fontWeight: "500" }}>{item.name}</div>
                  {item.note && <div style={{ fontSize: 11, color: C.muted }}>{item.note}</div>}
                  <div style={{ fontSize: 15, color: C.gold, fontWeight: "bold", marginTop: 2 }}>{fmt(item.price)}</div>
                </div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Combos section */}
      <div style={{ background: C.surface, borderTop: `1px solid ${C.border}`, padding: 20 }}>
        <div style={{ fontSize: 10, letterSpacing: 3, color: C.gold, marginBottom: 14 }}>🔥 COMBO DEALS</div>
        <div style={{ display: "flex", gap: 10, flexWrap: "wrap", paddingBottom: 6 }}>
          {combos.map(c => (
            <div key={c.id} style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: "14px 16px", minWidth: 150, flex: "1 1 160px" }}>
              <span style={{ fontSize: 26, display: "block", marginBottom: 8 }}>{c.emoji}</span>
              <span style={{ fontSize: 13, fontWeight: "bold", color: C.cream, display: "block" }}>{c.name}</span>
              <span style={{ fontSize: 11, color: C.muted, display: "block", marginTop: 3, marginBottom: 8 }}>{c.desc}</span>
              <span style={{ fontSize: 16, color: C.gold, fontWeight: "bold", display: "block" }}>{fmt(c.price)}</span>
              <span style={{ fontSize: 10, color: "#3aad72", display: "block", marginTop: 3 }}>Save {fmt(c.saving)}</span>
            </div>
          ))}
        </div>
      </div>

      <div style={{ padding: "16px 20px", textAlign: "center" }}>
        <p style={{ color: C.muted, fontSize: 10, letterSpacing: 1, lineHeight: 1.8 }}>
          THE 401 HOTEL & SUITES LTD · AWKA<br />
          Quiet. Private. Professional. Serenity.
        </p>
      </div>
    </div>
  );

  // ── ADMIN MODE ────────────────────────────────────────────────────────────
  const renderAdmin = () => (
    <div>
      {/* Admin tab switcher */}
      <div style={{ display: "flex", background: C.surface, borderBottom: `1px solid ${C.border}` }}>
        {[["menu", "📋 Menu Items"], ["combos", "🔥 Combos"]].map(([t, label]) => (
          <button key={t} onClick={() => setTab(t)}
            style={{ flex: 1, padding: "12px", border: "none", background: "transparent", color: tab === t ? C.gold : C.muted, fontFamily: "inherit", fontSize: 12, fontWeight: tab === t ? "bold" : "normal", cursor: "pointer", borderBottom: tab === t ? `2px solid ${C.gold}` : "2px solid transparent" }}>
            {label}
          </button>
        ))}
      </div>

      {tab === "menu" && (
        <div>
          {/* Category selector */}
          <div style={{ display: "flex", flexWrap: "wrap", background: C.card, borderBottom: `1px solid ${C.border}` }}>
            {menu.map(cat => (
              <button key={cat.id} onClick={() => setActiveCat(cat.id)}
                style={{ padding: "10px 13px", border: "none", background: "transparent", color: activeCat === cat.id ? cat.color : C.muted, fontFamily: "inherit", fontSize: 11, cursor: "pointer", whiteSpace: "nowrap", borderBottom: activeCat === cat.id ? `2px solid ${cat.color}` : "2px solid transparent" }}>
                {cat.icon} {cat.label}
              </button>
            ))}
          </div>

          {activeCatData && (
            <div style={{ padding: "16px 18px" }}>
              <div style={{ fontSize: 10, letterSpacing: 3, color: C.gold, marginBottom: 14 }}>
                EDITING: {activeCatData.label.toUpperCase()} · {activeCatData.items.length} items
              </div>

              {activeCatData.items.map(item => (
                <div key={item.id} style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: "14px", marginBottom: 10 }}>
                  {/* Image preview + emoji + name row */}
                  <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                    <div style={{ width: 48, height: 48, borderRadius: 10, overflow: "hidden", background: activeCatData.color + "15", border: `1px solid ${activeCatData.color}33`, display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0, fontSize: 24 }}>
                      {item.image
                        ? <img src={item.image} alt={item.name} style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                        : <span>{item.emoji}</span>}
                    </div>
                    <input style={{ ...inp, flex: 1 }} value={item.name}
                      onChange={e => updateItemName(activeCatData.id, item.id, e.target.value)} />
                    <button onClick={() => removeItem(activeCatData.id, item.id)}
                      style={{ background: C.red + "22", border: `1px solid ${C.red}44`, borderRadius: 8, padding: "6px 10px", color: C.red, cursor: "pointer", fontSize: 14, fontFamily: "inherit" }}>✕</button>
                  </div>
                  {/* Price row */}
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 10 }}>
                    <span style={{ fontSize: 11, color: C.muted, letterSpacing: 1, whiteSpace: "nowrap" }}>PRICE ₦</span>
                    <input type="number" style={{ ...inp, flex: 1 }} value={item.price}
                      onChange={e => updatePrice(activeCatData.id, item.id, e.target.value)} />
                    <span style={{ fontSize: 13, color: C.gold, fontWeight: "bold", minWidth: 80 }}>{fmt(item.price)}</span>
                  </div>
                  {/* Photo upload row */}
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <label style={{ display: "flex", alignItems: "center", gap: 6, background: item.image ? C.green + "22" : C.gold + "18", border: `1px solid ${item.image ? C.green + "55" : C.gold + "44"}`, borderRadius: 8, padding: "7px 12px", cursor: "pointer", fontSize: 12, color: item.image ? C.green : C.gold, whiteSpace: "nowrap", fontFamily: "inherit", fontWeight: "bold" }}>
                      {item.image ? "✓ Photo Set" : "📷 Upload Photo"}
                      <input type="file" accept="image/*" style={{ display: "none" }}
                        onChange={e => {
                          const file = e.target.files[0];
                          if (!file) return;
                          const reader = new FileReader();
                          reader.onload = ev => updateItemImage(activeCatData.id, item.id, ev.target.result);
                          reader.readAsDataURL(file);
                        }} />
                    </label>
                    {item.image && (
                      <>
                        <img src={item.image} alt="" style={{ width: 36, height: 36, objectFit: "cover", borderRadius: 6 }} />
                        <button onClick={() => updateItemImage(activeCatData.id, item.id, "")}
                          style={{ background: C.muted + "22", border: `1px solid ${C.muted}33`, borderRadius: 6, padding: "5px 10px", color: C.muted, cursor: "pointer", fontSize: 11, fontFamily: "inherit" }}>Remove</button>
                      </>
                    )}
                  </div>
                </div>
              ))}

              {/* Add new item */}
              {addingItem === activeCatData.id ? (
                <div style={{ background: `${C.green}12`, border: `1px solid ${C.green}33`, borderRadius: 12, padding: "16px", marginTop: 10 }}>
                  <div style={{ fontSize: 10, letterSpacing: 2, color: C.green, marginBottom: 12 }}>NEW ITEM</div>
                  <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
                    <input style={{ ...inp, width: 44 }} value={newItem.emoji} onChange={e => setNewItem({ ...newItem, emoji: e.target.value })} placeholder="🍽️" maxLength={2} />
                    <input style={{ ...inp, flex: 1 }} value={newItem.name} onChange={e => setNewItem({ ...newItem, name: e.target.value })} placeholder="Item name" />
                  </div>
                  <div style={{ display: "flex", gap: 8, marginBottom: 10 }}>
                    <input style={{ ...inp, flex: 1 }} placeholder="Note (optional)" value={newItem.note} onChange={e => setNewItem({ ...newItem, note: e.target.value })} />
                  </div>
                  {/* Photo upload for new item */}
                  <div style={{ display: "flex", alignItems: "center", gap: 8, marginBottom: 12 }}>
                    <label style={{ display: "flex", alignItems: "center", gap: 6, background: newItem.image ? C.green + "22" : C.surface, border: `1px solid ${newItem.image ? C.green + "55" : C.border}`, borderRadius: 8, padding: "8px 12px", cursor: "pointer", fontSize: 12, color: newItem.image ? C.green : C.muted, fontFamily: "inherit", fontWeight: "bold" }}>
                      {newItem.image ? "✓ Photo Added" : "📷 Add Photo (optional)"}
                      <input type="file" accept="image/*" style={{ display: "none" }}
                        onChange={e => {
                          const file = e.target.files[0];
                          if (!file) return;
                          const reader = new FileReader();
                          reader.onload = ev => setNewItem({ ...newItem, image: ev.target.result });
                          reader.readAsDataURL(file);
                        }} />
                    </label>
                    {newItem.image && (
                      <>
                        <img src={newItem.image} alt="" style={{ width: 36, height: 36, objectFit: "cover", borderRadius: 6 }} />
                        <button onClick={() => setNewItem({ ...newItem, image: "" })}
                          style={{ background: "transparent", border: `1px solid ${C.border}`, borderRadius: 6, padding: "5px 8px", color: C.muted, cursor: "pointer", fontSize: 11 }}>Remove</button>
                      </>
                    )}
                  </div>
                  <div style={{ display: "flex", gap: 8, alignItems: "center", marginBottom: 12 }}>
                    <span style={{ fontSize: 11, color: C.muted }}>PRICE ₦</span>
                    <input type="number" style={{ ...inp, flex: 1 }} value={newItem.price} onChange={e => setNewItem({ ...newItem, price: e.target.value })} placeholder="0" />
                  </div>
                  <div style={{ display: "flex", gap: 8 }}>
                    <button onClick={() => addItem(activeCatData.id)}
                      style={{ flex: 1, background: C.green, border: "none", borderRadius: 8, padding: "10px", color: "#fff", fontWeight: "bold", cursor: "pointer", fontFamily: "inherit" }}>
                      ✓ Add Item
                    </button>
                    <button onClick={() => { setAddingItem(null); setNewItem({ name: "", price: "", emoji: "🍽️", note: "", image: "" }); }}
                      style={{ background: "transparent", border: `1px solid ${C.border}`, borderRadius: 8, padding: "10px 14px", color: C.muted, cursor: "pointer", fontFamily: "inherit" }}>Cancel</button>
                  </div>
                </div>
              ) : (
                <button onClick={() => setAddingItem(activeCatData.id)}
                  style={{ width: "100%", marginTop: 10, background: `${C.green}15`, border: `1px dashed ${C.green}44`, borderRadius: 12, padding: "13px", color: C.green, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>
                  + Add New Item to {activeCatData.label}
                </button>
              )}
            </div>
          )}
        </div>
      )}

      {tab === "combos" && (
        <div style={{ padding: "16px 18px" }}>
          <div style={{ fontSize: 10, letterSpacing: 3, color: C.gold, marginBottom: 16 }}>COMBO DEALS</div>
          {combos.map(c => (
            <div key={c.id} style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 12, padding: "14px", marginBottom: 10 }}>
              <div style={{ display: "flex", gap: 8, marginBottom: 8 }}>
                <input style={{ ...inp, width: 44 }} value={c.emoji} onChange={e => updateCombo(c.id, "emoji", e.target.value)} maxLength={2} />
                <input style={{ ...inp, flex: 1 }} value={c.name} onChange={e => updateCombo(c.id, "name", e.target.value)} placeholder="Combo name" />
                <button onClick={() => removeCombo(c.id)} style={{ background: C.red + "22", border: `1px solid ${C.red}44`, borderRadius: 8, padding: "6px 10px", color: C.red, cursor: "pointer", fontSize: 14 }}>✕</button>
              </div>
              <input style={{ ...inp, width: "100%", boxSizing: "border-box", marginBottom: 8 }} value={c.desc} onChange={e => updateCombo(c.id, "desc", e.target.value)} placeholder="Description" />
              <div style={{ display: "flex", gap: 8 }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 10, color: C.muted, marginBottom: 4 }}>PRICE ₦</div>
                  <input type="number" style={{ ...inp, width: "100%", boxSizing: "border-box" }} value={c.price} onChange={e => updateCombo(c.id, "price", e.target.value)} />
                </div>
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 10, color: C.muted, marginBottom: 4 }}>SAVING ₦</div>
                  <input type="number" style={{ ...inp, width: "100%", boxSizing: "border-box" }} value={c.saving} onChange={e => updateCombo(c.id, "saving", e.target.value)} />
                </div>
              </div>
            </div>
          ))}
          <button onClick={addCombo} style={{ width: "100%", marginTop: 6, background: `${C.green}15`, border: `1px dashed ${C.green}44`, borderRadius: 12, padding: "13px", color: C.green, fontSize: 13, cursor: "pointer", fontFamily: "inherit" }}>
            + Add New Combo Deal
          </button>
        </div>
      )}

      {/* Export & save */}
      <div style={{ padding: "16px 18px", borderTop: `1px solid ${C.border}`, display: "flex", gap: 10 }}>
        <button onClick={exportSummary}
          style={{ flex: 1, background: C.card, border: `1px solid ${C.border}`, borderRadius: 10, padding: "12px", color: C.muted, cursor: "pointer", fontFamily: "inherit", fontSize: 12 }}>
          📥 Export Menu List
        </button>
        <button onClick={() => { flashSaved(); }}
          style={{ flex: 1, background: saved ? C.green : `linear-gradient(135deg,${C.gold},${C.goldLight})`, border: "none", borderRadius: 10, padding: "12px", color: saved ? "#fff" : C.bg, fontWeight: "bold", cursor: "pointer", fontFamily: "inherit", fontSize: 12, transition: "all 0.2s" }}>
          {saved ? "✓ Saved!" : "💾 Save Changes"}
        </button>
      </div>
    </div>
  );

  return (
    <div style={{ fontFamily: "'Palatino Linotype','Book Antiqua',Palatino,Georgia,serif", background: C.bg, minHeight: "100vh", color: C.cream, maxWidth: "100%", margin: "0 auto" }}>
      <NavBar title="Menu Editor" />
      <style>{`@media(min-width:768px){.pb{max-width:720px;margin:0 auto}.cr{display:grid!important;grid-template-columns:repeat(auto-fill,minmax(170px,1fr))!important}}`}</style>

      {/* Header */}
      <div style={{ background: C.surface, borderBottom: `1px solid ${C.border}`, padding: "14px 18px", display: "flex", alignItems: "center", justifyContent: "space-between", position: "sticky", top: 0, zIndex: 100 }}>
        <div>
          <div style={{ fontSize: 14, fontWeight: "bold", color: C.gold, letterSpacing: 2 }}>🍽️ 401 Menu</div>
          <div style={{ fontSize: 10, color: C.muted, letterSpacing: 1 }}>
            {mode === "admin" ? "⚙️ ADMIN — EDITING MODE" : "THE 401 HOTEL & SUITES LTD"}
          </div>
        </div>
        <div style={{ display: "flex", gap: 8 }}>
          {mode === "view" && (
            <button onClick={() => setMode("login")}
              style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 8, padding: "7px 12px", color: C.muted, cursor: "pointer", fontSize: 11, fontFamily: "inherit" }}>
              ⚙️ Admin
            </button>
          )}
          {mode === "admin" && (
            <>
              <button onClick={() => setMode("view")}
                style={{ background: C.card, border: `1px solid ${C.border}`, borderRadius: 8, padding: "7px 12px", color: C.muted, cursor: "pointer", fontSize: 11, fontFamily: "inherit" }}>
                👁 View Menu
              </button>
              <button onClick={() => { setMode("view"); setKeyInput(""); }}
                style={{ background: C.red + "22", border: `1px solid ${C.red}44`, borderRadius: 8, padding: "7px 12px", color: C.red, cursor: "pointer", fontSize: 11, fontFamily: "inherit" }}>
                🔒 Lock
              </button>
            </>
          )}
        </div>
      </div>

      {/* Pages */}
      <div style={{ paddingBottom: 40 }}>
        {mode === "view" && renderView()}
        {mode === "login" && renderLogin()}
        {mode === "admin" && renderAdmin()}
      </div>
    </div>
  );
}
